import {ButtonBase, type SxProps, type Theme, Typography} from '@mui/material';
import {COLORS} from '~/style/colors-ts';

export type PackTileProps = {
    selected: boolean;
    title: string;
    subtitle: string;
    onClick: () => void;
    sx?: SxProps<Theme>;
};

/** One selectable pack tile. Selected state uses the secondary palette. */
export const PackTile = ({selected, title, subtitle, onClick, sx}: PackTileProps) => (
    <ButtonBase
        onClick={onClick}
        sx={{
            flex: 1,
            alignItems:'start',
            justifyContent: 'space-between',
            flexDirection: 'column',
            py: 1.25,
            px: 1.5,
            borderRadius: 1,
            height: '56px',
            border: `2px solid ${selected ? COLORS.secondary[500] : COLORS.grey[100]}`,
            bgcolor: selected ? COLORS.secondary[100] : 'transparent',
            ...sx,
        }}
    >
        <Typography variant="body1" fontWeight={600} sx={{lineHeight: '14px'}}>{title}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{lineHeight: '14px'}}>{subtitle}</Typography>
    </ButtonBase>
);
